import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

import debounce from 'lodash/debounce';

gsap.registerPlugin(ScrollToPlugin);

const getScrollPercent = () => {
  const h = document.documentElement;
  const b = document.body;
  const st = 'scrollTop';
  const sh = 'scrollHeight';
  return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
};

let primaryNavHeight;

document.addEventListener('DOMContentLoaded', () => {
  const secondaryNavLinks = document.querySelectorAll('.secondaryNav-list li a');
  if (secondaryNavLinks.length === 0) {
    document.querySelector('.site-content').classList.remove('has_secondaryNav');
  }

  if (window.location.hash) {
    const section = document.getElementsByName(window.location.hash.substring(1));
    if (section.length !== 0) {
      gsap.to(window, { duration: 0.6, scrollTo: { y: section, offsetY: 200 } });
    }
  }

  if (document.getElementsByClassName('secondaryNav-container--pages').length === 0) {
    Array.from(secondaryNavLinks).forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        const linkName = event.target.getAttribute('href');
        const section = document.getElementsByName(linkName.substring(1))[0];
        window.location.hash = linkName;
        gsap.to(window, { duration: 0.6, scrollTo: { y: section, offsetY: 200 } });
      });
    });
  }

  primaryNavHeight = document.getElementById('primaryNav').clientHeight;
});

let position = document.documentElement.scrollTop;
const masthead = document.getElementById('masthead');
const actionBar = document.querySelector('.action-bar');
const actionBarInner = actionBar !== null ? actionBar.children[0] : null;
const bannerNotification = document.querySelector('.bannerNotification');

if (document.getElementById('secondaryNav') != null) {
  document.addEventListener(
    'scroll',
    debounce(() => {
      const scroll = document.documentElement.scrollTop;
      if (scroll > position) {
        const verticalScroll = getScrollPercent();
        if (verticalScroll > 10) {
          gsap.to(masthead, { duration: 0.3, y: `-${primaryNavHeight}` });

          if (actionBar !== null && actionBarInner.classList.contains('fixed')) {
            gsap.to(actionBarInner, { duration: 0.3, y: `-${primaryNavHeight}` });
          }

          if (
            bannerNotification !== null &&
            bannerNotification.querySelector('.scrolled') !== null
          ) {
            gsap.to(bannerNotification.querySelector('.scrolled'), {
              duration: 0.3,
              y: `-${primaryNavHeight}`,
            });
          }
        }
      } else {
        gsap.to(masthead, { duration: 0.3, y: 0 });

        if (actionBar !== null) {
          if (actionBarInner.classList.contains('fixed')) {
            gsap.to(actionBarInner, { duration: 0.3, y: 0 });
          } else {
            gsap.to(actionBarInner, { duration: 0, y: 0 });
          }
        }

        if (bannerNotification !== null && bannerNotification.querySelector('.scrolled') !== null) {
          gsap.to(bannerNotification.querySelector('.scrolled'), { duration: 0.3, y: 0 });
        }
      }

      position = scroll;
    }, 10),
  );
}
